import { useContext } from "react";
import { DesignSystemContext } from "./DesignSystemProvider.js";
const isTest = process.env.NODE_ENV === "test";
function useDateFnsLocale() {
  const context = useContext(DesignSystemContext);
  if (!context) {
    throw new Error("useDateFnsLocale cannot be used outside <DesignSystemProvider>");
  }
  if (!isTest && !context.dateFnsLocale) {
    console.error(`No locale from date-fns was provided to <DesignSystemProvider>. 
            Please provide a value for dateFnsLocale to localise the DatePicker.`);
  }
  return context.dateFnsLocale;
}
export {
  useDateFnsLocale
};
//# sourceMappingURL=useDateFnsLocale.js.map
